var SizingService = {
  initialize: function() {
  },
  setMinHeight($element, config) {
    let minHeight = 0;

    if(config.override) {
      $element.addClass('override-min-height');
    }

    if(config.value) {
      minHeight = this.getDimensionValueParsed(config.value, 'outerHeight');
    } else if(config.calculate) {
      minHeight = this.getDimensionValueCalculated(config.calculate, 'outerHeight');
    }

    $element.css({
      'min-height': minHeight
    });
  },
  getTotalForADimension(dimensionsArray, type) {
    let totalForADimension = 0;

    for(let item of dimensionsArray) {
      if(typeof(item) === 'number') {
        // dimension value can either be a number
        totalForADimension += item;
      } else {
        // or an element selector to get dimension value from
        if($(item).length) {
          totalForADimension += $(item)[type](true);
        }
      }
    }
    return totalForADimension;
  },
  getDimensionValueParsed(value, type) {
    // Value can be a literal (single value 100vh or 119px or calc(100vh - 119px))
    // or an array of jQuery Selectors (['.element1', '.element2'])
    // or an array of jQuery Selectors and numbers (['.element1', '.element2', 60]) to get dimension value from
    return Array.isArray(value) ? `${this.getTotalForADimension(value, type)}px` : value;
  },
  getDimensionValueCalculated(config, type) {
    const valueA  =  this.getDimensionValueParsed(config.valueA, type);
    const valueB  =  this.getDimensionValueParsed(config.valueB, type);
    const operations = {
      subtract: '-',
      add: '+'
    };

    return `calc(${valueA} ${operations[config.operation]} ${valueB})`;
  }
};

module.exports = SizingService;
